//#region types
import { RadioGroupProps, TextInputProps } from "models/propTypes/wintFormPropsTypes";
import { IncomingInvoiceFormTypes } from "models/formTypes";
import { TranslationKeys } from "translations";
import { AlreadyPaidStepProps } from "models/propTypes/incomingInvoicePropTypes";
import { CreditPaymentHandling } from "models/enums/incomingInvoice";
//#endregion
//#region components
import {
  Toggle,
  ExpandableSectionEmptyContent,
  RadioGroup,
  ExpandableSection,
  ExpandableSectionSummary,
  Description,
  VerticalFormField,
  TextAreaInput,
} from "components/common/wintForms";
import { Grid } from "@mui/material";
import { InfoTooltip, StaticInfoMessage } from "components/common";
//#endregion
import { EnumHelper, LocalizationHelperInstance } from "utils/helpers";
import { IconDefinitionConstants } from "utils/constants";

const AlreadyPaidStep: React.FC<AlreadyPaidStepProps<IncomingInvoiceFormTypes.Todo>> = ({
  connect,
  isCreditInvoice,
  noBankIntegration,
}) => {
  if (!isCreditInvoice) {
    return (
      <ExpandableSectionEmptyContent
        title={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.IsAlreadyPaid)}
        subText={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.IncomingInvoice.AlreadyPaidDescription)}
      >
      {noBankIntegration ? (
        <Grid container alignItems="center" direction="row" wrap="nowrap" spacing={1}>
          <Grid item>
            <Toggle {...connect("isAlreadyPaid")} disabled={true}/>
          </Grid>
          <Grid item>
            <InfoTooltip
              text={LocalizationHelperInstance.getFormattedMessage(
                TranslationKeys.IncomingInvoice.NoBankIntegrationToolTip
              )}
              icon={IconDefinitionConstants.WInfo}
              placement="top"
            />
          </Grid>
        </Grid>
      ) : (
        <Toggle {...connect("isAlreadyPaid")} disabled={false}/>
      )}
    </ExpandableSectionEmptyContent>
  );
}

const connectCreditPaymentHandling = connect("creditPaymentHandling");

  return (
    <ExpandableSection
      summary={
        <ExpandableSectionSummary
          title={LocalizationHelperInstance.getFormattedMessage(
            TranslationKeys.IncomingInvoice.CreditPaymentHandlingTitle
          )}
        />
      }
      alwaysOpen
    >
      <Grid container rowGap={2} marginTop={-3}>
        <Description>
          {LocalizationHelperInstance.getFormattedMessage(
            TranslationKeys.IncomingInvoice.CreditPaymentHandlingDescription
          )}
        </Description>
        <Grid container rowGap={1}>
          <VerticalFormField<RadioGroupProps>
            Component={RadioGroup}
            {...connectCreditPaymentHandling}
            items={EnumHelper.getNumericItemValues(CreditPaymentHandling).map((value) => ({
              id: value,
              value: LocalizationHelperInstance.getTranslatedEnumValue(
                "IncomingInvoice.CreditPayment",
                CreditPaymentHandling[value]
              ),
            }))}
            noOuterSpacing
          />
          {connectCreditPaymentHandling?.value === CreditPaymentHandling.Other && (
            <>
              <StaticInfoMessage>
                {LocalizationHelperInstance.getFormattedMessage(
                  TranslationKeys.IncomingInvoice.CreditPaymentHandlingInfoMessage
                )}
              </StaticInfoMessage>
              <VerticalFormField<TextInputProps>
                Component={TextAreaInput}
                {...connect("paymentHandlingInformation")}
                label={LocalizationHelperInstance.getFormattedMessage(
                  TranslationKeys.IncomingInvoice.DescribeCreditPaymentHandling
                )}
                rows={2}
                noOuterSpacing
              />
            </>
          )}
        </Grid>
      </Grid>
    </ExpandableSection>
  );
};

export default AlreadyPaidStep;
